import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import {TranslatePipe} from "@ngx-translate/core";

@Component({
  selector: 'app-under-development',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  template: `
    <div class="under-development-container">
      <div class="content">
        <i class="pi pi-wrench icon"></i>
        <h1>{{ 'The page is under development' | translate }}</h1>
        <p>{{ pageName | translate }} {{'page is coming' | translate}}.</p>
      </div>
    </div>
  `,
  styles: [`
    .under-development-container {
      display: flex;
      justify-content: start;
      align-items: start;
      min-height: 80vh;
      padding: 20px;
      background: var(--surface-ground);
    }

    .content {
      text-align: start;
      max-width: 500px;
    }

    .icon {
      font-size: 4rem;
      color: var(--primary-color);
      margin-bottom: 20px;
      display: block;
    }

    h1 {
      font-size: 2rem;
      color: var(--color-main-font);
      margin-bottom: 10px;
    }

    p {
      font-size: 1.1rem;
      color: var(--color-grey-font);
    }
  `]
})
export class UnderDevelopmentComponent {
  pageName = '';

  constructor(private route: ActivatedRoute) {
    this.route.data.subscribe(data => {
      this.pageName = data['title'] || 'Эта страница';
    });
  }
}
